module.exports = __webpack_public_path__ + "img/02_shoreline_library.43146b0a.jpg";